<template>
<div class="chapter">
<div class="inner_page">
<div id="d2-d5f88a5f148ed-d1e411">
<h2 class="chapter-number ">TWO</h2>
<h2 class="chapter-title ">The Harlem River</h2>
<p class="flush-left-opener " style="text-indent:0;"><span class="drop-cap char-drop-cap">S</span>till vigorous at eighty-one, Gary’s father, Charlie Stephens, is kayaking under the stars twenty or so yards down from the Macombs Dam Bridge that spans the Harlem River. When his wetsuit starts to vibrate, he stops and unzips his pocket.</p><span id="page6">
<p class="indented ">His son’s voice on the phone says, ‘Pop, it’s Gary. Guess what? The Chinese are going to the moon! It’s on TV!’</p>
<p class="indented ">A tractor-trailer rumbles by on the bridge above.</p>
<p class="indented ">‘Who? What?’</p>
<p class="indented ">Back in Tumulty’s, the Mets are rallying. Gary raises his voice over the bar’s noise. ‘The Chinese government. Instead of another satellite, they’ll be sending a manned rocket to the moon. You’re back in business!’</p>
<p class="indented ">Charlie lets his kayak drift with the current.</p>
<p class="indented ">‘Me? I don’t think so. This retirement bit is too much fun. Besides, NASA is all out of money.’</p>
<p class="indented ">Gary’s still enthusiastic. ‘If not NASA, the networks. Nobody does video simulations like you do.’</p>
<p class="indented ">His father paddles once to avoid a channel marker.</p>
<p class="indented ">‘Did. Like I <em><em class="char-italic italic">did</em></em>. It’s all up to you now, kiddo.’</p>
<p class="indented ">The younger man’s voice on the phone is incredulous. ‘Me? I do commercials for dog food. And yogurt.’</p>
<p class="indented ">To Charlie’s left, Yankee Stadium is all lit up, getting ready for the season. He remembers going to a doubleheader there with his own dad.</p>
<p class="indented ">‘As I said, I’m retired.’</p>
<p class="indented ">‘Just wait till CBS or ABC start calling.’</p>
<p class="indented ">‘Then I’ll do to them what I’m doing to you. Bye.’</p>
<p class="indented ">Charlie presses the end button, and the call is over. Smiling, he lets the kayak float under the stars. A moment later, the full moon overhead is eclipsed as he drifts under the Madison Avenue Bridge at East 138th Street.</p>
<p class="indented ">Looking up at the iron girders and trusses of the nineteenth-century structure gliding away behind him, the retiree doesn’t notice the canoe that pushes off from behind the bridge’s stone footings near the far shore. The two men paddling it, their black wetsuits zipped all the way up to their chins, silently overtake him.</p>
<p class="indented ">When they come alongside, the shorter man, a dark watch cap pulled down so only his eyes are visible, takes hold of the kayak by the bow. The much taller one, his shaved black head reflecting light from the channel marker, grabs the stern. Together, they begin to tip it over. Charlie only has time for a quick yelp.</p>
<p class="indented ">‘Hey, what—’</p>
<p class="indented ">Encased as he is, Charlie goes over with his boat. He uses his paddle to try to right himself, but together the men are too strong. Though the kayak rocks violently back and forth, he can’t come up for air.</p><span id="page7">
<p class="indented ">Eventually, the rocking ends and his paddle pops to the surface and floats off. The men glide away as quietly as they came, and the overturned kayak drifts down the river under the moon.</p></span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781448303595_epub_chap003.vue?1f26d37a